import React, {PropTypes, Component} from 'react';
import classnames from 'classnames';

import './App.css';

export default class DeletePhotosExceptFavorites extends Component {
	render() {
    	const {className, ...props} = this.props;
    	return (
      		<div style={styles.mainContainer}>
      			<h3>Delete Photos Except Favorites</h3>
      			<div style={styles.descriptionContainerDiv}>
      				<div style={styles.descriptionDiv}>
		        		This app let's you delete all photos except the ones you have marked as favorites. 
		        		If you have backed up your photos and want to delete them from the iPhone to clear some space, 
		        		but still keep some of the best ones, this app is for you. 
		        		Make sure to back up your photos before using this app!
        			</div>
        		</div>
      		</div>
    	);
  	}
}

const styles = {
	mainContainer:{
		display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
	},
	descriptionContainerDiv: {
		display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
	},
    descriptionDiv: {
        marginTop: 0,
        width: 600,
        textAlign: 'center',
    },
};


// WEBPACK FOOTER //
// ./src/DeletePhotosExceptFavorites.js